export default function Container({ children, title, description }: { children: React.ReactNode, title: string, description: string }) {
  return (
    <div className="container">
        <div className="container-info">
        <h3>{title}</h3>
        <span>{description}</span>
        </div>
        <div className="container-body">
            {children}
        </div>
    </div>
  );
}
